import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import backIcon from "../../assets/images/back.svg";
import "../../assets/scss/components/templates/back.scss";
import { console_log } from "../../utils/commonHelper";

const BackBtn = (props, { backButtonPress }) => {
  const navigate = useNavigate();

  const goBack = () => {
    console_log("props", props);
    if (props.to) {
      console_log("props inside");
      navigate(props.to);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="back-btn">
      <h6 className="back" onClick={backButtonPress || goBack}>
        <Image src={backIcon} />
        Back
      </h6>
    </div>
  );
};

export default BackBtn;
